import React, { forwardRef, useState } from 'react';
import { readOnlyAction, useAdminAccess } from 'contexts/adminAccess';
import { FieldProps, InjectedFieldProps } from 'react-admin';
import MenuItem from '@material-ui/core/MenuItem';

import EditTierDialog from './EditTierDialog';
import { AchTierConfigDto } from '../types';

type Props = (FieldProps & InjectedFieldProps) & {
  record?: AchTierConfigDto;
};

const EditTierField = forwardRef<HTMLLIElement, Props>(({ record }, ref) => {
  const { canManageBilling } = useAdminAccess();
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <MenuItem ref={ref} onClick={handleOpen}>
        {canManageBilling ? 'Edit' : 'View'}
      </MenuItem>

      {open && <EditTierDialog open={open} onClose={handleClose} record={record} />}
    </>
  );
});

export default readOnlyAction(EditTierField, 'canReadBilling');
